import { lazy } from 'react';

import { type RouteComponentProps } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { BillListPageStatuses } from '@webapp/pages/BillListPage'
import messages from './messages'

export interface BillCreatePageParams {
  uuid?: uuid
}

const BillCreateContainerChunk = lazy(() =>
  import('../containers/BillCreateContainer').then(
    ({ BillCreateContainer }) => ({
      default: BillCreateContainer,
    })
  )
)

export const BillCreatePage = (
  props: RouteComponentProps<BillCreatePageParams>
) => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.billCreatePageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.manageBillsPageTitle),
          link: url('BillListPage', {
            status: BillListPageStatuses.DRAFT,
          }),
        },
        { name: intl.formatMessage(messages.billCreatePageTitle) },
      ]}
    >
      <BillCreateContainerChunk billUUID={props.match.params?.uuid} />
    </Page>
  )
}
